module.exports = __webpack_public_path__ + "img/rewardBtn.4774ccb1.png";